import axios from '../utils/axios';
import qs from 'qs';
// import store from "@/store";
/**
 * 语言提示
 * @param params
 * @returns {*}
 */
export async function getKey (params) {

  return await axios.GET('/v1/language/getKey', params);
}

/**
 * v获取平台信息
 * @param params
 * @returns {*}
 */
export async function getUserInfo (params) {

  return await axios.GET('/v1/auth/getAppInfo', params);
}

/**
 * 登录
 * @param params
 * @returns {*}
 */
export async function getUserToken (params) {

  return await axios.GET('/v1/auth/access_token', params);
}

/**
 * 获取代理商、单位、群组、用户 数量
 * @param params
 * @returns {*}
 */
export async function getFaststats (params) {

  return await axios.GET('/v1/profile/faststats', params);
}


/**
 * 获取代理商信息
 * @param params
 * @returns {*}
 */
export async function getAgent (params) {

  return await axios.GET('/v1/profile/agent', params);
}


/**
 * 获取未读通知提醒数量
 * @param params
 * @returns {*}
 */
export async function getNewUnreadCount (params) {

  return await axios.GET('/v1/notice/newUnreadCount', params);
}

/**
 * 修改所在地区
 * @param params
 * @returns {*}
 */
export async function changeArea (params) {

  return await axios.POST(`/v1/profile/area?` + qs.stringify(params));
}

/**
 * 发验证码
 * @param params
 * @returns {*}
 */
export async function sendSms (params) {

  return await axios.GET(`/v1/jsp/sendSms`, params);
}

/**
 * 修改联系人姓名
 * @param params
 * @returns {*}
 */
export async function upContact (params) {

  return await axios.POST(`/v1/profile/contact?` + qs.stringify(params));
}


/**
 * 修改续费联系方式
 * @param params
 * @returns {*}
 */
export async function upModifying (params) {

  return await axios.POST(`/v1/agent/ModifyingAgentInformation?` + qs.stringify(params));
}

/**
 * 修改地址
 * @param params
 * @returns {*}
 */
export async function upAddress (params) {

  return await axios.POST(`/v1/profile/address?` + qs.stringify(params));
}

/**
 * 验证旧手机号验证码
 * @param params
 * @returns {*}
 */
export async function upVerificationCode (params) {

  return await axios.GET(`/v1/jsp/verificationCode`, params);
}

/**
 * 验证旧手机号验证码
 * @param params
 * @returns {*}
 */
export async function updatePhone (params) {

  return await axios.GET(`/v1/agent/updatePhone`, params);
}

/**
 * 个人信息-修改密码
 * @param params
 * @returns {*}
 */
export async function editpassword (params) {

  return await axios.POST(`/v1/profile/password?` + qs.stringify(params));
}

/**
 * 问题反馈
 * @param params
 * @returns {*}
 */
export async function feedbackSend (params) {

  return await axios.POST(`/v1/feedback/send?` + qs.stringify(params));
}

/**
 * 验证码是否有效
 * @param params
 * @returns {*}
 */
export async function getVerificationCode (params) {

  return await axios.GET(`/v1/jsp/verificationCode`, params);
}


/**
 * 个人信息-修改支付密码
 * @param params
 * @returns {*}
 */
export async function editpaypassword (params) {

  return await axios.GET(`/v1/jsp/updateCardPwd`, params);
}

/**
 * 用户列表
 * @param params
 * @returns {*}
 */
export async function getUserList (params) {

  return await axios.GET(`/v1/terminal/list`, params);
}


/**
 * 获取详情
 * @param params
 * @returns {*}
 */
export async function getCardCount (params) {

  return await axios.GET(`/v1/agent/getCardCount`, params);
}

/**
 * 验证密码是否正确
 * @param params
 * @returns {*}
 */
export async function examinePwd (params) {

  return await axios.GET(`/v1/jsp/checkPwd`, params);
}

/**
 * 开通服务
 * @param params
 * @returns {*}
 */
export async function addService (params) {

  return await axios.GET(`/v1/terminal/addService`, params);
}
/**
 * 用户详情
 * @param params
 * @returns {*}
 */
export async function userDetail (params) {

  return await axios.GET(`/v1/terminal/detail`, params);
}

/**
 * 修改用户接口
 * @param params
 * @returns {*}
 */
export async function updateUser (params) {

  return await axios.POST(`/v1/terminal/updateUser?` + qs.stringify(params));
}

/**
 * 回收卡
 * @param params
 * @returns {*}
 */
export async function cardBack (params) {

  return await axios.GET(`/v1/terminal/cardBack`, params);
}

// // 围栏提示
// export async function isUpdateUser(params) {

//   return await axios.POST(`/v1/terminal/isUpdateUser?` + qs.stringify(params));
// }


/**
 * 修改用户IMEI
 * @param params
 * @returns {*}
 */
export async function changecard (params) {

  return await axios.POST(`/v1/terminal/changecard?` + qs.stringify(params));
}


/**
 * 创建用户
 * @param params
 * @returns {*}
 */
export async function addUser (params, paramsA) {

  return await axios.POST(`/v1/terminal/batch?` + qs.stringify(params), paramsA);
}


/**
 * 修改电话号码
 * @param params
 * @returns {*}
 */
export async function upMobile (params) {

  return await axios.POST(`/v1/profile/mobile?` + qs.stringify(params));
}

/**
 * 修改邮箱地址
 * @param params
 * @returns {*}
 */
export async function editEmail (params) {

  return await axios.POST(`/v1/profile/email?` + qs.stringify(params));
}

/**
 * 绑定手机及支付密码
 * @param params
 * @returns {*}
 */
export async function sendpassword (params) {

  return await axios.GET(`/v1/jsp/setPhoneAndPwd`, params);
}


//获取验证图片
export async function getImgHk (params) {
  return await axios.GET(`/v1/auth/getImg`, params);
}

//验证是否通过
export async function verifyImageCode (params) {
  return await axios.GET(`/v1/auth/verifyImageCode`, params);
}

//获取sos数量
export async function untreatedSOSCount (params) {

  return await axios.POST(`/v1/sos/untreatedSOSCount?` + qs.stringify(params));
}


//对讲用户重置密码
export async function resetIntercomPassword (params) {

  return await axios.POST(`/v1/terminal/resetIntercomPassword?` + qs.stringify(params));
}


//查询用户状态
export async function useronlinestatus (params, paramsA) {
  return await axios.POST("/v1/terminal/useronlinestatus?" + params, paramsA)
}